<template>
  <div class="text-center mb-5">
    <img
      v-if="domainKey==='tably'"
      src="@/platform/assets/images/logo-tably-horizontal-text.svg"
      style="width: 80px; height: auto;">
    <img
      v-else
      src="@/platform/assets/images/logo-yumiwi-horizontal-text.svg"
      style="width: 80px; height: auto;">
  </div>
</template>
<script>
export default {
  data () {
    return {
      domainKey: window.expresoAppState.domainKey
    }
  }
}
</script>
